import { useMutation, useQueryClient } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";

export function useDeleteRemoveJobLink() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ jobId }: { jobId: string }) => {
      const path = `jobs/${jobId}/links`;
      await guacHttpClient.delete(path);
    },
    onSuccess: () => {
      // Unlinking changes every former group member's family list.
      void queryClient.invalidateQueries({ queryKey: ["job-links"] });
    },
  });
}
